import { Box, Heading } from "@vinomofo/components";

export interface DividerHeadingProps {
  label: string;
}

export const DividerHeading = ({ label }: DividerHeadingProps): JSX.Element => {
  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box
        as="hr"
        border={0}
        borderBottom="1px solid"
        borderBottomColor="divider"
        flexGrow={1}
        mr={3}
      />
      <Heading
        color="inherit"
        fontFamily="heading"
        fontSize={10}
        fontWeight={500}
      >
        {label}
      </Heading>
      <Box
        as="hr"
        border={0}
        borderBottom="1px solid"
        borderBottomColor="divider"
        flexGrow={1}
        ml={3}
      />
    </Box>
  );
};
